import { Variant } from "lib/enum"
import * as enm from "lib/enum"

interface timePeriodMap {
	Day: undefined
	Week: undefined
	Month: undefined
	Year: undefined
}

export type TimePeriodTag = keyof timePeriodMap

export class TimePeriod extends Variant<timePeriodMap> {
	ToMs(count: int): int {
		return this.Match({
			Day: () => count * 24 * 60 * 60 * 1000,
			Week: () => count * 7 * 24 * 60 * 60 * 1000,
			Month: () => count * 30 * 24 * 60 * 60 * 1000,
			Year: () => count * 365 * 24 * 60 * 60 * 1000,
		})
	}

	ToStr(count?: int): string {
		return this.Match({
			Day: () => `Last ${count} day${count === 1 ? "" : "s"}`,
			Week: () => ` ${count} week${count === 1 ? "" : "s"}`,
			Month: () => `${count} month${count === 1 ? "" : "s"}`,
			Year: () => `${count} year${count === 1 ? "" : "s"}`,
		})
	}
}

export const TimePeriodTags = ["Day", "Week", "Month", "Year"] as Array<keyof timePeriodMap>

export const TimePeriods = enm.New(TimePeriodTags.Map((t) => new TimePeriod(t, undefined)))

export function IsAllTime(value: string): value is "AllTime" {
	return value.Equal("AllTime")
}

export function IsTimePeriodTag(value: string): value is TimePeriodTag {
	return TimePeriods.Contains(value as TimePeriodTag)
}

export function Day(): TimePeriod {
	return new TimePeriod("Day", undefined)
}
export function Week(): TimePeriod {
	return new TimePeriod("Week", undefined)
}
export function Month(): TimePeriod {
	return new TimePeriod("Month", undefined)
}

export function Year(): TimePeriod {
	return new TimePeriod("Year", undefined)
}
